// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"6573dbfa","213":"9e7bde2b","475":"baec7b6c","580":"2a99c0e6","591":"f0938731","747":"9a57d74c"}[chunkId] + ".chunk.js";
};